<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 39 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M38.935 6.309h-23.695c-0.255-0.001-0.461-0.207-0.462-0.461v-1.846c0.001-0.255 0.207-0.461 0.461-0.462h23.695c0.255 0.001 0.461 0.207 0.462 0.461v1.846c-0.001 0.255-0.207 0.461-0.461 0.462h-0zM39.396 18.155v-1.846c-0.001-0.255-0.207-0.461-0.461-0.462h-23.695c-0.255 0.001-0.461 0.207-0.462 0.461v1.846c0.001 0.255 0.207 0.461 0.461 0.462h23.695c0.253-0.003 0.457-0.208 0.458-0.461v-0zM39.396 30.462v-1.846c-0.001-0.255-0.207-0.461-0.461-0.462h-23.695c-0.255 0.001-0.461 0.207-0.462 0.461v1.85c0.001 0.255 0.207 0.461 0.461 0.462h23.695c0.253-0.003 0.457-0.208 0.458-0.461v-0zM5.27 26.462c-0.008-0-0.018-0-0.028-0-1.527 0-2.766 1.238-2.766 2.766s1.238 2.766 2.766 2.766c1.527 0 2.766-1.238 2.766-2.765v0c0-0 0-0 0-0 0-1.518-1.223-2.75-2.736-2.765h-0.001zM13.156 0.84l-0.569-0.569c-0.167-0.168-0.399-0.272-0.654-0.272s-0.487 0.104-0.654 0.272l-6.062 6.091-2.954-2.954c-0.167-0.168-0.399-0.272-0.654-0.272s-0.487 0.104-0.654 0.272l-0.691 0.691c-0.168 0.167-0.272 0.399-0.272 0.654s0.104 0.487 0.272 0.654l4.176 4.176c0.167 0.168 0.399 0.272 0.654 0.272s0.487-0.104 0.654-0.272l0.016-0.016 7.377-7.407c0.176-0.169 0.285-0.406 0.285-0.669 0-0.255-0.103-0.486-0.27-0.654l0 0zM13.187 13.147l-0.569-0.569c-0.167-0.168-0.399-0.272-0.654-0.272s-0.487 0.104-0.654 0.272l-6.062 6.091-2.958-2.954c-0.167-0.168-0.399-0.272-0.654-0.272s-0.487 0.104-0.654 0.272l-0 0-0.669 0.691c-0.168 0.167-0.272 0.399-0.272 0.654s0.104 0.487 0.272 0.654l4.176 4.176c0.167 0.168 0.399 0.272 0.654 0.272s0.487-0.104 0.654-0.272l0-0-0.016-0.016 7.407-7.407c0.166-0.169 0.268-0.402 0.268-0.658s-0.102-0.488-0.268-0.658l0 0z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
